import * as angular from 'angular';
import { CreditGapsWizardSubjectTableComponent } from './credit-gaps-wizard-subject-table.component';

export const CreditGapsWizardSubjectTableModule = angular
  .module('creditGapsWizardSubjectTableModule', [])
  .component('creditGapsWizardSubjectTable', CreditGapsWizardSubjectTableComponent).name;
